import { Grid } from "@mui/material";
import { memo } from "react";
import { Instance as TinyColor } from 'tinycolor2'
import ColorSwatch from "../colorSwatch/colorSwatch";

export type PredefinedSwatchesProps = {
    value: TinyColor,
    swatches: TinyColor[],
    onColorSelect: (value: TinyColor) => void
}

const PredefinedSwatches: React.FC<PredefinedSwatchesProps> = ({value, swatches, onColorSelect}) => {
    return (
        <Grid gap={0.5} flexDirection='row' display='flex' flexWrap='wrap' justifyContent='flex-start'>
            {swatches.map((sw, i) => <ColorSwatch key={sw.toHex8String()} value={sw} onClick={onColorSelect} selected={value.toHexString() === sw.toHexString()}/>)}
        </Grid>
    );
}


export default memo(PredefinedSwatches)